'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingServices = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BookingServices, _Component);

  function BookingServices(props) {
    (0, _classCallCheck3.default)(this, BookingServices);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BookingServices.__proto__ || (0, _getPrototypeOf2.default)(BookingServices)).call(this, props));

    _this.state = {
      style: _this.props.style || require('./Detail.scss')
    };
    return _this;
  }

  (0, _createClass3.default)(BookingServices, [{
    key: 'render',
    value: function render() {
      var styles = this.state.style;
      var _props = this.props,
          shop = _props.shop,
          groupServices = _props.groupServices;

      var services = groupServices.flatMap(function (item) {
        return item.services;
      });
      var servicesDivider = Math.ceil((services.length - 1) / 2) + 1;
      var priceRange = shop.minPrice && shop.maxPrice ? _support.Helper.formatMoney(shop.minPrice) + ' - ' + _support.Helper.formatMoney(shop.maxPrice) : shop.priceRange;
      return _react2.default.createElement(
        'div',
        {
          className: styles.contentTab + ' ' + styles.services,
          id: 'services',
          ref: 'services'
        },
        _react2.default.createElement(
          'div',
          { className: styles.headerTab },
          _react2.default.createElement(
            'h2',
            { className: styles.leftHeaderTab },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'th-large' }),
            'D\u1ECBch v\u1EE5',
            _react2.default.createElement(
              'span',
              { className: styles.span },
              'T\u1ED5ng c\u1ED9ng: ',
              services.length,
              ' d\u1ECBch v\u1EE5\u2003Gi\xE1: ',
              priceRange
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyTab },
          _react2.default.createElement(
            'div',
            { className: styles.serviceColumn },
            services && services.slice(0, servicesDivider).map(function (item) {
              return _react2.default.createElement(
                'div',
                { key: item._id, className: styles.serviceItem },
                _react2.default.createElement(
                  'span',
                  { className: styles.serviceName },
                  item.name
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.servicePrice },
                  _support.Helper.formatMoney(item.price)
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.serviceColumn },
            services && services.slice(servicesDivider, services.length).map(function (item) {
              return _react2.default.createElement(
                'div',
                { key: item._id, className: styles.serviceItem },
                _react2.default.createElement(
                  'span',
                  { className: styles.serviceName },
                  item.name
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.servicePrice },
                  _support.Helper.formatMoney(item.price)
                )
              );
            })
          )
        )
      );
    }
  }]);
  return BookingServices;
}(_react.Component), _class.propTypes = {
  shop: _react.PropTypes.object,
  style: _react.PropTypes.any,
  groupServices: _react.PropTypes.array
}, _temp);
exports.default = BookingServices;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/BookingServices.js
// module id = 1666
// module chunks = 0